import React from "react";
import "./style.css";
import firstRightImg from "../Assets/firstRightImg.png";
import frame1 from "../Assets/firstFrame1.png";
import frame2 from "../Assets/firstFrame2.png";
import frame3 from "../Assets/firstFrame3.png";

import aeonDiff from "../Assets/aeonDiffImg.png";

import aeonDiff1 from "../Assets/aeonDiffImg1.png";
import aeonDiff2 from "../Assets/aeonDiffImg2.png";
import aeonDiff3 from "../Assets/aeonDiff3.png";
import softDev from "../Assets/coreCapaImgs/softDevImg.png";
import digiImg from "../Assets/coreCapaImgs/digiImg.png";
import iotImg from "../Assets/coreCapaImgs/iotImg.png";
import consultImg from "../Assets/coreCapaImgs/consultImg.png";
import tiImg from "../Assets/coreCapaImgs/tiImg.png";
import chooseImg1 from "../Assets/chooseImgs/expertDelivery.png";
import clientCentric from "../Assets/chooseImgs/clientCentric.png";
import futureReady from "../Assets/chooseImgs/futureReady.png";
import postLaunch from "../Assets/chooseImgs/postLaunch.png";
import scalable from "../Assets/chooseImgs/scalable.png";
import agile from "../Assets/chooseImgs/agile.png";
import androidDevImg from "../Assets/whatWeOffer/androidDev.png";
import cloudDevImg from "../Assets/whatWeOffer/cloudDev.png";
import webDevImg from "../Assets/whatWeOffer/webDev.png";
import smallRobot from "../Assets/whatWeOffer/smallRobot.png";
import smallRobot2 from "../Assets/whatWeOffer/smallRobot2.png";
import { Link } from "react-router-dom";
import HomeRightSvg from "./HomeRightSvg";

function Home({ handleShowContact }) {
  return (
    <>
      <div className="first-container">
        <div className="row m-0 h-100">
          <div className="col-xxl-7 col-xl-6 col-lg-6 p-0">
            <div className="first-left">
              <div>
                <h1 className="m-0 font-cardo cardo-heading">
                  Innovating the <span className="span-1">Future of </span>{" "}
                  <span className="span-2">Digital</span> Intelligence
                </h1>
              </div>
              <div className="first-left-sub-text font-inter">
                <p>
                  Custom solutions in <span>software development, IoT,</span>{" "}
                  <span>digitization,</span> and <span>consulting</span>{" "}
                  designed for tomorrow.
                </p>
              </div>
              <Link
                to="/services"
                className="request-demo-btn"
                style={{ textDecoration: "none" }}
              >
                <span>Explore Our Services</span>
              </Link>
            </div>
          </div>
          <div className="col-xxl-5 col-xl-6 col-lg-6 p-0">
            <div className="first-right">
              <div className="first-right-inner">
                 <div className="front">
                <div className="polygon">
                  <svg
                    width="441"
                    height="385"
                    viewBox="0 0 441 385"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M326.186 1.89117C328.363 1.887 330.388 2.97204 331.592 4.76314L331.822 5.13038L438.304 188.751C439.469 190.76 439.474 193.238 438.317 195.251L332.538 379.278C331.453 381.166 329.501 382.377 327.348 382.524L326.915 382.54L114.653 382.946C112.476 382.951 110.452 381.866 109.247 380.074L109.018 379.707L2.53491 196.087C1.36995 194.078 1.36556 191.599 2.52282 189.586L108.301 5.55906C109.386 3.67154 111.338 2.46073 113.491 2.31316L113.925 2.29766L326.186 1.89117Z"
                      stroke="url(#paint0_linear_3205_10035)"
                      stroke-width="3"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_3205_10035"
                        x1="330.802"
                        y1="0.382359"
                        x2="110.037"
                        y2="384.455"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#AC82FF" />
                        <stop offset="1" stop-color="#1F3C94" />
                      </linearGradient>
                    </defs>
                  </svg>

                  <img
                    className="firstRightImg"
                    src={firstRightImg}
                    alt="future of digital"
                  />
                </div>

                <div className="dot1">
                  <img
                    className="frame1"
                    src={frame1}
                    alt="frame1"
                  />
                </div>

                <div className="dot2">
                  <img
                    className="frame2"
                    src={frame2}
                    alt="frame2"
                  />
                </div>
                <div className="dot3">
                  <img
                    className="frame3"
                    src={frame3}
                    alt="frame3"
                  />
                </div>
              </div>
              <div className="back">
                <div className="polygon">
                  <svg
                    width="441"
                    height="385"
                    viewBox="0 0 441 385"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M326.186 1.89117C328.363 1.887 330.388 2.97204 331.592 4.76314L331.822 5.13038L438.304 188.751C439.469 190.76 439.474 193.238 438.317 195.251L332.538 379.278C331.453 381.166 329.501 382.377 327.348 382.524L326.915 382.54L114.653 382.946C112.476 382.951 110.452 381.866 109.247 380.074L109.018 379.707L2.53491 196.087C1.36995 194.078 1.36556 191.599 2.52282 189.586L108.301 5.55906C109.386 3.67154 111.338 2.46073 113.491 2.31316L113.925 2.29766L326.186 1.89117Z"
                      stroke="url(#paint0_linear_3205_10035)"
                      stroke-width="3"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_3205_10035"
                        x1="330.802"
                        y1="0.382359"
                        x2="110.037"
                        y2="384.455"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#AC82FF" />
                        <stop offset="1" stop-color="#1F3C94" />
                      </linearGradient>
                    </defs>
                  </svg>

                  <img
                    className="firstRightImg"
                    src={firstRightImg}
                    alt="future of digital"
                  />
                </div>

                <div className="dot1">
                  <img
                    className="frame1"
                    src={frame1}
                    alt="frame1"
                  />
                </div>

                <div className="dot2">
                  <img
                    className="frame2"
                    src={frame2}
                    alt="frame2"
                  />
                </div>
                <div className="dot3">
                  <img
                    className="frame3"
                    src={frame3}
                    alt="frame3"
                  />
                </div>
              </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
      <div className="second-container ">
        <div className="second-inner-container">
          <div className="row m-0">
            <div className="col-xl-6 col-lg-6 p-0">
              <div className="first-left h-100">
                <h1 className="m-0 font-cardo cardo-heading cardo-heading2">
                  Aeon Difference
                </h1>
                <div className="diff-container mt-4">
                  <h3 className="diff-subHead font-cardo mb-3">Who We Are</h3>
                  <p className="first-left-sub-text font-inter mb-5">
                    We are a forward-thinking technology company dedicated to
                    creating seamless <span>digital experiences</span>. Our team
                    combines deep technical expertise with industry insight to
                    deliver scalable and intelligent solutions.
                  </p>
                  <h3 className="diff-subHead font-cardo mb-3">What We Do</h3>
                  <p className="font-inter first-left-sub-text">
                    From advanced software development to{" "}
                    <span>IoT integration</span> and{" "}
                    <span>strategic consulting</span>, we empower businesses
                    through digital transformation. Our unique approach to{" "}
                    <span>True Intelligence (TI)</span> blends data, logic, and
                    design to drive smarter decisions and real impact.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 p-0">
              <div className="diff-right">
                <img className="diffImg2" src={aeonDiff2} alt="aeonDifference" />
                <img className="diffImg1" src={aeonDiff1} alt="aeonDifference" />
                
              </div>
            </div>
          </div>
          <img
            className="mt-4 aeonDiff3"
            src={aeonDiff3}
            alt="img"
          />
        </div>
      </div>
      <div className="third-container">
        <div className="third-inner-container">
          <h1 className="m-0 font-cardo cardo-heading cardo-heading2">Core Capabilities</h1>
          <div className="font-inter inter-para mt-3">
            A modern, icon-driven section with short descriptors under each:
          </div>
          <div className="capa-container">
            <div className="row m-0 justify-content-center">
              <div className="col-xl-6 col-lg-6 col-md-6 ps-0 pe-0 pe-xl-3 pe-lg-3">
                <div className="capa-box">
                  <div className="capa-box-inner">
                    <img src={softDev} alt="software development" />
                    <h3 className="m-0 capa-box-head font-cardo">
                      Software Development
                    </h3>
                    <div className="font-inter">
                      <p>Tailored solutions for web, mobile, and enterprise platforms</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 pe-0 ps-0 ps-xl-3 ps-lg-3">
                <div className="capa-box">
                  <div className="capa-box-inner">
                    <img src={digiImg} alt="software development" />
                    <h3 className="m-0 capa-box-head font-cardo">
                      Digitization
                    </h3>
                    <div className="font-inter">
                      <p>Transforming traditional workflows into smart digital systems</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 ps-0 pe-0 pe-xl-3 pe-lg-3">
                <div className="capa-box">
                  <div className="capa-box-inner">
                    <img src={iotImg} alt="software development" />
                    <h3 className="m-0 capa-box-head font-cardo">
                      IoT-Based Solutions
                    </h3>
                    <div className="font-inter">
                      <p>Smart device integration to
                      streamline and enhance operations</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 pe-0 ps-0 ps-xl-3 ps-lg-3">
                <div className="capa-box">
                  <div className="capa-box-inner">
                    <img src={consultImg} alt="software development" />
                    <h3 className="m-0 capa-box-head font-cardo">Consulting</h3>
                    <div className="font-inter">
                      <p>Insight-driven strategies to scale
                      innovation and efficiency</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 pe-0 ps-0">
                <div className="capa-box">
                  <div className="capa-box-inner">
                    <img src={tiImg} alt="software development" />
                    <h3 className="m-0 capa-box-head font-cardo">
                      True Intelligence (TI)
                    </h3>
                    <div className="font-inter">
                      <p>Combining data, AI, and intuitive
                      design to drive real-world results</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fourth-container">
        <div className="fourth-inner-container">
          <h1 className="m-0 font-cardo cardo-heading cardo-heading2">Why Choose Us</h1>
          <div className="font-inter inter-para mt-3">
            We don’t just build software, we build long-term partnerships.
            Here’s why businesses choose us:
          </div>
          <div className="fourth-box-container">
            <div className="row m-0">
              <div className="col-xl-6 col-lg-6 col-md-6 ps-0 pe-0 pe-lg-4">
                <div className="row m-0">
                  <div className="col-12 p-0">
                    <div className="choose-box">
                      <div className="choose-box-inner">
                        <div className="">
                          <img src={chooseImg1} alt="img" width={"60px"} />
                        </div>
                        <div className="font-inter text-start">
                          <h5 className="inter-para-head m-0">
                            Expertise That Delivers
                          </h5>
                          <div className="inter-para mt-2 text-start">
                            Our team brings years of experience across
                            industries and technologies to deliver quality
                            solutions on time, every time.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 p-0">
                    <div className="choose-box">
                      <div className="choose-box-inner">
                        <div className="">
                          <img src={futureReady} alt="img" width={"60px"} />
                        </div>
                        <div className="font-inter text-start">
                          <h5 className="inter-para-head m-0">
                            Future-Ready Technologies
                          </h5>
                          <div className="inter-para mt-2 text-start">
                            From IoT to True Intelligence (TI), we integrate the
                            latest innovations to keep you ahead of the curve.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 p-0">
                    <div className="choose-box">
                      <div className="choose-box-inner">
                        <div className="">
                          <img src={agile} alt="img" width={"60px"} />
                        </div>
                        <div className="font-inter text-start">
                          <h5 className="inter-para-head m-0">
                            Agile & Transparent Process
                          </h5>
                          <div className="inter-para mt-2 text-start">
                            We work in short, focused sprints with full
                            visibility, so you're always in control of the
                            project.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 mt-0 mt-lg-5 pe-0 ps-0 ps-lg-4">
                <div className="row m-0">
                  <div className="col-12 p-0">
                    <div className="choose-box">
                      <div className="choose-box-inner">
                        <div className="">
                          <img src={clientCentric} alt="img" width={"60px"} />
                        </div>
                        <div className="font-inter text-start">
                          <h5 className="inter-para-head m-0">
                            Client-Centric Approach
                          </h5>
                          <div className="inter-para mt-2 text-start">
                            We focus on your goals, challenges, and vision to
                            craft solutions that actually make an impact.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 p-0">
                    <div className="choose-box">
                      <div className="choose-box-inner">
                        <div className="">
                          <img src={scalable} alt="img" width={"60px"} />
                        </div>
                        <div className="font-inter text-start">
                          <h5 className="inter-para-head m-0">
                            Scalable Solutions
                          </h5>
                          <div className="inter-para mt-2 text-start">
                            Whether you're a startup or an enterprise, our
                            solutions are built to grow with you.{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 p-0">
                    <div className="choose-box">
                      <div className="choose-box-inner">
                        <div className="">
                          <img src={postLaunch} alt="img" width={"60px"} />
                        </div>
                        <div className="font-inter text-start">
                          <h5 className="inter-para-head m-0">
                            Post-Launch Support
                          </h5>
                          <div className="inter-para mt-2 text-start">
                            We don’t disappear after delivery we offer ongoing
                            support, updates, and optimization.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fifth-container">
        <div className="fifth-inner-container">
          <div className="ps-4">
            <h5
              className="font-inter inter-purple-text m-0 text-start"
              style={{ fontWeight: "600" }}
            >
              Our Services
            </h5>
            <h1 className="m-0 font-cardo cardo-heading cardo-heading2 mt-5">What We Offer</h1>
            <p className="font-inter inter-para mt-3">
              Crafting tailored digital solutions to help your business thrive
              in a connected world.
            </p>
          </div>
          <div className="hr-grey"></div>
          <div className="mb-5">
            <div className="ps-lg-5 mt-5 ps-0">
              <div className="row m-0">
                <div className="col-lg-6 ps-0 pe-0 pe-sm-4">
                  <div className="row m-0">
                    <div className="col-12 p-0">
                      <div className="offer-box">
                        <div className="card">
                          <img
                            src={androidDevImg}
                            className="card-img-top"
                            alt="Android Developer"
                          />
                          <div className="card-body">
                            <h5 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-4">
                              Android Development
                            </h5>
                            <p className="card-text text-start font-inter inter-para">
                              We build fast, reliable, and intuitive mobile apps
                              designed for performance and user satisfaction.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 p-0">
                      <div className="offer-box mb-0">
                        <div className="card">
                          <img
                            src={cloudDevImg}
                            className="card-img-top"
                            alt="Cloud Developer"
                          />
                          <div className="card-body">
                            <h5 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-4">
                              Cloud Development
                            </h5>
                            <p className="card-text text-start font-inter inter-para">
                              From scalable APIs to full cloud-native platforms,
                              we engineer backend systems built for the future.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6 pe-0 ps-0 ps-lg-4 alternate-col"
                  // style={{ marginTop: "170px" }}
                >
                  <div className="row m-0 right-row">
                    <div className="col-12 p-0">
                      <div className="offer-box">
                        <div className="card">
                          <img
                            src={webDevImg}
                            className="card-img-top"
                            alt="Web App Developer"
                          />
                          <div className="card-body">
                            <h5 className="card-title text-start font-cardo cardo-purple-text fw-bold mb-4">
                              Web App Development
                            </h5>
                            <p className="card-text text-start font-inter inter-para">
                              Clean, modern, and responsive web applications
                              that work seamlessly across devices.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 p-0 alternate-col2">
                      <div className="offer-box mb-0">
                        <div className="card">
                          <div className="d-flex justify-content-between align-items-center w-100 px-2">
                            <img
                              src={smallRobot}
                              className="smallRobot"
                              alt="Android Developer"
                            />
                            <Link
                              to="/services"
                              className="services-btn"
                            >
                              See All
                            </Link>
                          </div>
                          <div className="card-body">
                            <h4 className="card-title text-start font-cardo card-heading fw-bold">
                              We also offer tailored solutions beyond this list.
                              Let’s talk about what you need.
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="hr-grey"></div>
          <div className="ps-3 ps-lg-5 mt-5">
            <div className="offer-section">
              <div className="text-start">
                <h4 className="font-cardo cardo-purple-text fw-bold mb-5">
                  <p className="mb-2">
                    We also offer tailored solutions beyond this list.
                  </p>{" "}
                  Let’s talk about what you need.
                </h4>
                <button
                  className="request-demo-btn"
                  onClick={handleShowContact}
                >
                  <span>Let's Get In Touch</span>
                  <svg
                    width="16"
                    height="13"
                    viewBox="0 0 19 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.41797 16.0837L16.5846 1.91699M16.5846 1.91699H3.83464M16.5846 1.91699V14.667"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
              <div className="smallRobot2">
                <img src={smallRobot2} alt="img" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
